import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';
import { NuDsContext } from '@nubank/nuds-web/components/NuDSProvider/NuDSProvider';

import Image from '@nubank/www-latam-commons/components/Image/Image';
import { smoothScroll as handleLinkClick } from 'utils/domUtils';

function SectionPromo({ index }) {
  const { formatMessage } = useContext(NuDsContext);

  return (
    <Grid
      row
      tag="section"
      alignItems="center"
      spacingHorizontal={{
        xs: '4x',
        md: '8x',
        lg: '12x',
      }}
      spacingVertical={{
        xs: '12x',
        md: '20x',
        lg: '32x',
      }}
    >
      <Grid
        order={{ lg: 2 }}
        offset={{ lg: 1 }}
        col={{
          xs: 12,
          md: 10,
          lg: 5,
        }}
      >
        <Box
          marginBottom={{
            xs: '8x',
            md: '4x',
            lg: '0x',
          }}
        >
          <Typography
            variant="title"
            colorVariant="default"
            gutterBottom={1.5}
            gutterTop={1.5}
            intlKey={`cms.pixPage.pixCardsArea[${index}].title`}
          />

          <Typography
            variant="subtitle"
            colorVariant="default"
            gutterBottom={1.5}
            intlKey={`cms.pixPage.pixCardsArea[${index}].description`}
          />

          <Link
            onClick={handleLinkClick}
            href={formatMessage({ id: `cms.pixPage.pixCardsArea[${index}].ctaLink` })}
            variant="action"
            iconProps={{ name: 'arrow-up' }}
            intlKey={`cms.pixPage.pixCardsArea[${index}].ctaText`}
          />
        </Box>
      </Grid>

      <Grid
        order={{ lg: 1 }}
        offset={{ md: 6, lg: 1 }}
        col={{
          xs: 12,
          md: 6,
          lg: 4,
        }}
      >
        <Image
          altIntlKey="PIX.PROMO.IMAGE_ALT"
          srcSet={{
            xs: {
              '1x': 'bubble-gum-woman-square/bubble-gum-woman-square@xs-1x.jpg',
              '2x': 'bubble-gum-woman-square/bubble-gum-woman-square@xs-2x.jpg',
            },
            md: {
              '1x': 'bubble-gum-woman-square/bubble-gum-woman-square@md-1x.jpg',
              '2x': 'bubble-gum-woman-square/bubble-gum-woman-square@md-2x.jpg',
            },
            lg: {
              '1x': 'bubble-gum-woman-square/bubble-gum-woman-square@lg-1x.jpg',
              '2x': 'bubble-gum-woman-square/bubble-gum-woman-square@lg-2x.jpg',
            },
          }}
        />
      </Grid>
    </Grid>
  );
}

SectionPromo.propTypes = {
  index: PropTypes.number.isRequired,
};

export default React.memo(SectionPromo);
